module.exports = __webpack_public_path__ + "img/9B4816_E8A138_CC7421_DC8827-256px.17882839.png";